import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TranslateModule } from '@ngx-translate/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CmsComponent } from './components/cms/cms.component';
import { LanguageComponent } from './components/language/language.component';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component';
import { TitleCaseCustomPipe } from './pipes/title-case-custom.pipe';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list'
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import { OnlynumberDirective } from './directives/numbersOnly.directive';
import { InputCharDirective } from './directives/input-char.directive';
import {MatExpansionModule} from '@angular/material/expansion';
import { HeaderIntlComponent } from './components/header-intl/header-intl.component';
import { FooterIntlComponent } from './components/footer-intl/footer-intl.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { MatIconModule } from '@angular/material/icon';
import { JSBAngularFlipClockModule } from 'jsb-angular-flip-clock';
import { FlipCounterComponent } from './components/flip-counter/flip-counter.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import  {  NgxProgressiveImgLoaderModule  }  from  'ngx-progressive-img-loader';

const exportComponents: any = [
  HeaderComponent,
  FooterComponent,
  CmsComponent,
  ChatBotComponent,
  LanguageComponent,
  HeaderIntlComponent,
  FooterIntlComponent,
  FlipCounterComponent,
];

const exportDirectives = [
  OnlynumberDirective,
  InputCharDirective
];

const exportPipes = [
  TitleCaseCustomPipe,
];

const exportModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NgxChartsModule,
  MatInputModule,
  MatSelectModule,
  MatListModule,
  TranslateModule,
  MatMenuModule,
  MatExpansionModule,
  MatCheckboxModule,
  MatDialogModule,
  AccordionModule,
  MatIconModule,
  JSBAngularFlipClockModule,
  SlickCarouselModule,
  NgxSkeletonLoaderModule,
  NgxProgressiveImgLoaderModule,
];
@NgModule({
  declarations: [
    ...exportComponents,
    ...exportDirectives,
    ...exportPipes
  ],
  imports: [
    ...exportModules,
    CarouselModule.forRoot(),
  ],
  exports: [
    ...exportComponents,
    ...exportDirectives,
    ...exportModules,
    ...exportPipes,
    CarouselModule,
    PopoverModule
  ]
})
export class SharedModule { }
